<template>
	<p-data-table :value="userData" ref="user_data_table" data-key="user_id" class="user-data-table" scrollable>
		<template #empty>
			<div class="dim">No Data</div>
		</template>
		<p-column header="Team" class="user-row-name-cell">
			<template #body="row">
				<template v-if="teamId === 'account_manager'">
					<strong
						><router-link :to="{ name: 'AMBookTracker', params: { account_manager_id: row.data.user_id } }">{{
							row.data.user_name
						}}</router-link></strong
					>
				</template>
				<template v-else-if="teamId === 'account_executive'">
					<strong
						><router-link :to="{ name: 'AEBookTracker', params: { account_manager_id: row.data.user_id } }">{{
							row.data.user_name
						}}</router-link></strong
					>
				</template>
				<template v-else>
					<strong>{{ row.data.user_name }}</strong>
				</template>
			</template>
		</p-column>
		<p-column header="Spend" class="column-align-right">
			<template #body="row">
				{{ currency(row.data.spend, 0) }}<br />
				<div class="sub-value" v-html="trend(row.data.spend, row.data.compare_spend)" />
			</template>
		</p-column>
		<p-column header="Purchases" class="column-align-right">
			<template #body="row">
				{{ numberFormat(row.data.purchases) }}<br />
				<div class="sub-value" v-html="trend(row.data.purchases, row.data.compare_purchases)" />
			</template>
		</p-column>
		<p-column header="RPL" class="column-align-right">
			<template #body="row">
				{{ currency(row.data.rpl) }}<br />
				<div class="sub-value" v-html="trend(row.data.rpl, row.data.compare_rpl)" />
			</template>
		</p-column>
		<p-column header="Active Accounts" class="column-align-right">
			<template #body="row">
				<template v-if="teamId !== 'ltas'">
					{{ numberFormat(row.data.active_accounts) }}<br />
					<div class="sub-value" v-html="trend(row.data.active_accounts, row.data.compare_active_accounts)" />
				</template>
			</template>
		</p-column>
		<p-column header="Spend/Account" class="column-align-right">
			<template #body="row">
				<template v-if="teamId !== 'ltas'">
					{{ currency(row.data.spa) }}<br />
					<div class="sub-value" v-html="trend(row.data.spa, row.data.compare_spa)" />
				</template>
			</template>
		</p-column>
	</p-data-table>
</template>

<script>
import { currency, numberFormat, trend } from '@/lib/Filters';

export default {
	name: 'SalesPerformanceTable_UserSubTable',
	props: {
		teamId: String,
		userData: {
			type: Array,
			default() {
				return [];
			},
		},
	},
	methods: {
		currency,
		numberFormat,
		trend,
	},
};
</script>
